<!-- <div class="col-md-9 mx-auto pt-5" *ngIf="!showVendorDetail">
    <h3 class="small-30">Add New Supplier</h3>
    <div class="row">
        <div class="col-md-6 col-lg-5 col-xl-3 mb-3">
            <input type="text" class="form-control" (keyup)="vendorCodeInput($event)" placeholder="Enter Vendor Code" style="height: 45px;"/>
            <span class="text-danger" *ngIf="vendorCodeError">{{vendorCodeErrorMsg}}</span>
        </div>
        <div class="col-md-6 col-lg-5 col-xl-3">
            <button class="w-100 border text-white rounded bold new-btn2" style="height: 45px;" (click)="requestVendorAccess()">Request Access <i *ngIf="showSpnier" class="fa fa-spinner fa-spin"></i></button>
        </div>
    </div>
</div> -->

<section class="vr-tabs-section" *ngIf="!showVendorDetail">
  <div class="container-fluid pt-5 pb-5">
    <div class="row">
      <!-- <div class="col-md-3 vr-left-tab-col">

      </div> -->
      <div class="col-md-12 mx-auto vr-right-tab-col">
        <div class="vr-left-tab-col-div new-tabs main-tabs-color">
          <div class="nav  nav-pills vr-left-tab" id="v-pills-tab" role="tablist" aria-orientation="vertical">


            
            <a class="nav-link cp pbb-line" (click)="openTab('newSuppliers')"
              [ngClass]="{ 'active': current_tab == 'newSuppliers'}" id="v-pills-profile-tab" data-toggle="pill"
              role="tab" aria-controls="v-pills-profile" aria-selected="false"> Explore new suppliers</a>
              <a class="nav-link cp pbb-line" (click)="openTab('mySuppliers')"
              [ngClass]="{ 'active': current_tab == 'mySuppliers'}" id="v-pills-home-tab" data-toggle="pill" role="tab"
              aria-controls="v-pills-home" aria-selected="true"> My Suppliers</a>


          </div>
        </div>
        <div class="tab-content vr-right-tab-col-div" id="v-pills-tabContent"
          style="background-color: transparent; padding-left: 0; padding-right: 0;">
          <div class="tab-pane fade" *ngIf="current_tab == 'mySuppliers'"
            [ngClass]="{ 'show active': current_tab == 'mySuppliers'}" role="tabpanel"
            aria-labelledby="v-pills-home-tab">

            <div class="vendors-boxes-row d-flex flex-wrap">
              <ng-template ngFor [ngForOf]="delerVendors" let-vendor>
                <a *ngIf="!!vendor.disabled_at" data-toggle="tooltip"
                  title="Please upgrade your plan to access this supplier."
                  class="vendors-boxes vendors-disabled-boxes d-flex align-items-center justify-content-center">
                  <img [src]="(vendor.logo ? vendor.logo : defaultUserImg)  | imagePath" class="img-fluid">
                </a>
                <a *ngIf="!vendor.disabled_at" (click)="redirectToVendorProfile(vendor, 1)"
                  class="vendors-boxes d-flex align-items-center justify-content-center" style="cursor: pointer">
                  <img [src]="(vendor.logo ? vendor.logo : defaultUserImg) | imagePath" class="img-fluid">
                </a>
              </ng-template>
            </div>
          </div>
          <div class="tab-pane fade" *ngIf="current_tab == 'newSuppliers'"
            [ngClass]="{ 'show active': current_tab == 'newSuppliers'}" role="tabpanel"
            aria-labelledby="v-pills-profile-tab">
            <div class="vendors-boxes-row d-flex flex-wrap">
              <ng-template ngFor [ngForOf]="allVendors" let-newVendor>
                <div class="new-supplier-box vendors-boxes" (click)="redirectToVendorProfile(newVendor, 0)" style="cursor: pointer">
                  <div class="image-height-box">
                    <img [src]="(newVendor.logo ? newVendor.logo : defaultUserImg) | imagePath"
                      [ngClass]="{ 'default-user-img': !newVendor.logo}" class="img-fluid mx-auto" />
                  </div>
                  <a class="supplier-anchr cp" (click)="requestVendorAccess(newVendor.vendor_code)"
                    *ngIf="newVendor.is_approved == -1">
                    <!-- <span>
                      <i class="fa fa-plus-circle" aria-hidden="true"></i>
                    </span> -->
                    Add Supplier
                    <i *ngIf="showSpnier && newVendor.vendor_code == vendorCode" class="fa fa-spinner fa-spin"></i>
                  </a>
                  <a class="supplier-anchr" *ngIf="newVendor.is_approved == 0">
                    <!-- <span>
                      <i class="fa fa-check-circle success" aria-hidden="true"></i>
                    </span> -->
                    Request Sent
                  </a>
                </div>
              </ng-template>

            </div>
          </div>
          <div class="row text-center"
            *ngIf="current_tab == 'newSuppliers' && !loadMoreProducts && hasNextPage && allVendors.length">
            <div class="col-12">
              <button type="button" class="btn btn-02 f-large addcart cart-btn text-white bg-black w-auto px-5"
                (click)="loadMore()">Load More</button>
            </div>
          </div>
          <app-preloader *ngIf="current_tab == 'newSuppliers' && loadMoreProducts"></app-preloader>
        </div>
      </div>
    </div>

  </div>
</section>


<!-- <section class="vr-tabs-section">
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Home</a>
    </li>
  </ul>
  <div class="tab-content vr-right-tab-col-div" id="myTabContent">
    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">...</div>
  </div>
</section> -->


<!-- <div class="col-md-9 mt-5 mx-auto" *ngIf="!showVendorDetail">
    <span class="small-30 supplier-tab">My Supplier</span>

</div> -->

<div *ngIf="!showVendorDetail">
  <!-- <div class="py-3" style="background-color: #F2F1F3; min-height: calc(100vh - 277px);">
        <div class="col-md-9 mt-4 mx-auto">



            <div class="vendors-boxes-row d-flex flex-wrap">
              <ng-template ngFor [ngForOf]="delerVendors" let-vendor>
                <a *ngIf="!!vendor.disabled_at" data-toggle="tooltip" title="Please upgrade your plan to access this supplier." class="vendors-boxes vendors-disabled-boxes d-flex align-items-center justify-content-center">
                    <img [src]="vendor.logo | imagePath" class="img-fluid">
                </a>
                <a *ngIf="!vendor.disabled_at" routerLink="/supplier/{{vendor.id}}" class="vendors-boxes d-flex align-items-center justify-content-center">
                    <img [src]="vendor.logo | imagePath" class="img-fluid">
                </a>
              </ng-template>
            </div>

        </div>
    </div> -->
  <!-- <div class="col-md-9 mt-4 mx-auto">



        <div class="table-responsive supplier-table">
            <table class="table w-100 cart-table table-bordered">
                <thead>
                    <tr>
                        <th class="text-left text-primary">Name</th>
                        <th class="text-center text-primary">Status</th>
                        <!-- <th class="text-center text-primary">Sales Rep</th> - ->
                        <!-- <th class="text-center text-primary">Discount</th> - ->
                        <!-- <th class="text-right text-primary">Action</th> - ->
                    </tr>
                </thead>
                <tr *ngFor="let vendor of delerVendors">
                    <td class="text-left">
                        {{vendor.name}}
                        <!-- <img [src]="vendor.avatar | imagePath" class="tableimg class-responsive float-right" /> - ->
                    </td>
                    <td class="text-center">
                        <span class="approve" *ngIf="vendor.status">Approved</span>
                        <span class="pending" *ngIf="!vendor.status">Pending</span>
                    </td>
                    <!-- <td class="text-center" * ng If="vendor.representative_id">
                        <p class="mb-0"> { { vendor.representative?.name } } </p>
                        <p class="mb-0"> { { vendor.representative?.phone } } </p>
                        <p class="mb-0"> { { vendor.representative?.email } } </p>
                    </td>
                    <td class="text-center" * ngI f="!vendor.representative_id">
                        <p class="mb-0"> - </p>
                    </td>
                    <td class="text-center">
                        { { vendor.discount } }%
                    </td> -->
  <!-- <td class="text-right">
                        <button type="button" class="btn btn-warning text-white"><img src="assets/img/eye.svg" class="viewicon"> View</button>
                        <button type="button" class="btn btn-info"><img src="assets/img/edit.svg" class="editicon"> Edit</button>
                        <button type="button" class="btn btn-danger"> <img src="assets/img/trash.svg" class="trashicon">Delete</button>
                    </td> - ->
                </tr>
            </table>
        </div>

    </div> -->
</div>






<!--  -->
<!--  -->
<!--  -->
<!--  -->
<!--  -->
<!--  -->
<!--  -->
<!--  -->

<!-- Vendor detail page start here -->
<!-- <div class="container" [hidden]="!showVendorDetail">
    <div class="row" >
        <div class="col-md-6" *ngIf="showVendorDetail">
            <div class="row">
                <div class="col-md-12">
                    <div class="vendor-logo">
                        <img [src]="vendorProfileDetail.vendor.logo | imagePath"  class="img-fluid">
                    </div>
                </div>
            </div>

            <div class="vendor-text">
                <div class="row">
                    <div class="col-md-12 d-flex mb-3">
                        <label>Vendors:</label>
                        <p>{{ vendorProfileDetail.vendor.name }}</p>
                    </div>
                    <div class="col-md-12 d-flex mb-3">
                        <label>Sales Representative:</label>
                        <p *ngIf="vendorListData.representative_id">
                            <span>{{ vendorListData.representative?.name }}</span>
                            <span>J{{ vendorListData.representative?.email }}</span>
                        </p>
                        <p *ngIf="!vendorListData.representative_id"> - </p>
                    </div>
                    <div class="col-md-12 d-flex mb-3">
                        <label>Discount:</label>
                        <p>{{vendorListData.discount}}%</p>
                    </div>
                    <div class="col-md-12 d-flex mb-3">
                        <label>Lifetime purchese:</label>
                        <p>263,000$</p>
                    </div>
                </div>

            </div>
        </div>


        <div class="col-md-6">
            <div class="map-wrap">
                <canvas id="myChart" height="400px"></canvas>
            </div>

        </div>
    </div>
</div> -->


<section class="vr-tabs-section" *ngIf="showVendorDetail">
  <div class="container-fluid  pt-5 pb-5">
    <div class="row">

      <div class="col-md-12 vr-right-tab-col">
        <div class="col-md-12" *ngIf="showVendorDetail">
          <a routerLink="/suppliers" class="black text-black"><i class="fa fa-long-arrow-left"
              aria-hidden="true"></i></a>
        </div>
        <div class="vr-left-tab-col-div new-tabs">
          <div class="nav  nav-pills vr-left-tab" id="v-pills-tab" role="tablist" aria-orientation="vertical">

            <a class="nav-item nav-link {{ tabName=='profile'?'active':''}}"
              (selectedTabClick)="resetProductData($event, 'profile')" id="nav-home-tab" data-toggle="tab"
              href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Suppliers Profile</a>
            <a class="nav-item nav-link {{ tabName=='product'?'active':''}}"
              (selectedTabClick)="resetProductData($event, 'product')" id="nav-profile-tab" data-toggle="tab"
              href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Products</a>
            <a *ngIf="vendorListData?.is_approved == 1" class="nav-item nav-link {{ tabName=='invoice'?'active':''}}"
              (selectedTabClick)="setTabNameTo($event, 'invoice')" id="nav-contact-tab" data-toggle="tab"
              href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Invoices</a>

          </div>
        </div>
        <div class="tab-content vr-right-tab-col-div" id="v-pills-tabContent" *ngIf="showVendorDetail">


          <div class="tab-pane fade {{ tabName=='profile'?'show active':''}}" id="nav-home" role="tabpanel"
            aria-labelledby="nav-home-tab">
            <h4 class="d-flex align-items-center justify-content-between mb-4">
              Suppliers Information</h4>

            <div class="row">
              <!-- main Row -->
              <!-- left row -->
              <div class="col-md-12 col-lg-6 col-12">
                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    Business Name:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{vendorListData?.business_name}}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    Business Address:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{vendorListData?.business_address}}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    State:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{vendorListData?.state}}
                  </div>
                </div>


                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    Country:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{vendorListData?.country}}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    License Number:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{vendorListData?.vendor_code}}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    Sales Rep:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{ vendorListData?.representative?.name }}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    Contact:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{ vendorListData?.phone }}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    Email:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{ vendorListData?.email }}
                  </div>
                </div>
              </div>


              <!-- right row -->
              <div class="col-md-12 col-lg-6 col-12">
                <!-- <div class="row mb-2">
                              <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                                Website:
                              </div>
                              <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                                {{ vendorListData.email }}
                              </div>
                            </div>

                            <div class="row mb-2">
                              <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                                instagram:
                              </div>
                              <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                                {{ vendorListData.email }}
                              </div>
                            </div> -->

                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    Discount:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    {{vendorListData?.discount}}%
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-12 col-sm-5 col-xl-3 col-lg-4 sm-right">
                    Status:
                  </div>
                  <div class="col-12 col-sm-7 col-xl-9 col-lg-8 medium-font">
                    <span class="approve" *ngIf="vendorListData?.is_approved== 1">Authorized</span>
                    <span class="approve" *ngIf="vendorListData?.is_approved== 0">Pending</span>
                    <button class="btn btn-dark add-vendor-btn" (click)="requestVendorAccess(vendorListData.vendor_code)"  *ngIf="vendorListData?.is_approved == -1">Add Supplier</button>
                  </div>
                </div>

              </div>
            </div>
          </div>


          <div class="tab-pane fade {{ tabName=='product'?'show active':''}}" id="nav-profile" role="tabpanel"
            aria-labelledby="nav-profile-tab">
            <div class="listing-section">
              <!-- Product Listing  - Start-->
              <div class="row">
                <div class="col-md-12 bg-white">
                  <div class="listing-wrap listing-wrap-new {{ showProducts?'':'hiddenblock' }}">
                    <span *ngFor="let product of vendorProducts"
                      (click)="redirectToVatiants(suppliersId, product.slug, product?.prod_variants[0]?.rim_diameter, product.name, product.images, product.finish.finish)"
                      class="listing-box">
                      <div class="listing-image">
                        <img [src]="product.images | baseImage | imagePath" fetchpriority="low" loading="lazy"
                          decoding="async" />
                      </div>
                      <h5>{{ product.name }} - {{ product.finish.finish }}</h5>
                    </span>
                    <span *ngIf="!vendorProducts.length" class="listing-box">
                      <h5>No Product Found.</h5>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Product Listing  - Ends-->

              <!-- product moresizes listing Starts-->
              <div class="row {{ showProducts?'hiddenblock':'' }}">


                <div class="col-12">

                  <!-- <div class="col-md-12 bg-white">
                            <div class="listing-wrap">
                                <div class="top-section d-flex align-items-center mb-0">
                                    <span (click)=backToProducts()><i class="fa fa-long-arrow-left"></i> Go Back</span>
                                    <h4 class="mb-0 new-font">{{ selectedProdName }}</h4>
                                </div>

                                <div class="right-img d-flex justify-content-end">
                                    <img [src]="selectedProdImg | baseImage | imagePath" etchpriority="low" loading="lazy" width="150" height="150" decoding="async" />
                                </div>

                            </div>
                        </div> -->

                  <div class="top-section d-flex align-items-center mb-0">
                    <a (click)=backToProducts()>
                      <i class="fa fa-long-arrow-left"></i>
                    </a>
                    <div class="logo-wrap">
                      <img [src]="supplierLogo | imagePath" class="img-fluid">
                    </div>
                    <h4 class="mb-0 new-font">{{ selectedProdName }}</h4>
                  </div>
                </div>
              </div>
              <div class="row {{ showProducts?'hiddenblock':'' }}">

                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                  <h3 class="text-left f-26 d-flex align-items-end new-font h-100 pb-3">More Size & Options</h3>
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
                  <div class="right-img">
                    <img [src]="selectedProdImg | baseImage | imagePath" etchpriority="low" loading="lazy"
                      decoding="async" class="img-fluid" />
                  </div>

                </div>

                <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                  <div class="inner-scroll">
                    <ul class="nav nav-tabs nav-justified search-nav-tabs details-tabs" id="myTab" role="tablist">

                      <li class="nav-item" role="presentation" *ngFor="let type of wheelSizeTypes">
                        <a class="nav-link" [class.active]="activeTab==''" data-toggle="tab"
                          href="{{type.rim_diameter}}"
                          (click)="SupplierProductsVariants(suppliersId, product, type.rim_diameter)">{{
                          type.rim_diameter }}″</a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-0">
                  <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                      <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                        <div class="table-responsive">
                          <table class="table details-table ">
                            <thead>
                              <tr>
                                <th>Part No.</th>
                                <th>Finish</th>
                                <th>Size</th>
                                <th>Bolt Pattern</th>
                                <th>Offset</th>
                                <th>Weight</th>
                                <th>Stock</th>
                                <th></th>
                              </tr>
                            </thead>

                            <tbody *ngIf="vendorProductsVariants.length > 0">
                              <tr *ngFor="let size of vendorProductsVariants">
                                <td><a [routerLink]="['/', product, size.sku]" class="no-styling">{{ size.sku }}</a>
                                </td>
                                <td>{{ size?.product?.finish?.finish }}</td>
                                <td>{{ size.size }}</td>
                                <td>{{ size.bolt_pattern }}</td>
                                <td>{{ size.offset }}</td>
                                <td>{{ size.weight }}</td>
                                <td *ngIf='size.total_quantity > 0'><span class='in-stk'>In Stock</span></td>
                                <td *ngIf='size.total_quantity <= 0'><span class='out-stk'>Out Of Stock</span></td>
                                <td><a [routerLink]="['/', product, size.sku]" [queryParams]="{ vendor: vendorListData.id }" class="no-styling">View</a></td>
                              </tr>
                            </tbody>
                            <tbody *ngIf="vendorProductsVariants.length <= 0">
                              <tr>
                                <td colspan="8">
                                  <h6 class="alert alert-danger">No Variants Found</h6>
                                </td>
                              </tr>
                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- product moresizes listing Ends-->

            </div>
          </div>


          <div class="tab-pane fade {{ tabName=='invoice'?'show active':''}}" id="nav-contact" role="tabpanel"
            aria-labelledby="nav-contact-tab">
            <div class="invoice-accordian" *ngIf="!showOrderDetail">
              <div class="accordion" id="accordionExample">
                <div class="card" *ngFor="let monthData of myOrders; let i=index">
                  <div class="card-header">
                    <h2 class="mb-0">
                      <button class="btn btn-link" type="button" data-toggle="collapse"
                        [attr.data-target]="'#collapse'+i" aria-expanded="false">
                        <span>{{monthData.month}}</span>
                        <span>{{monthData.total_amount | currency: '$ ' }}</span>
                      </button>
                    </h2>
                  </div>
                  <div [id]="'collapse'+i" class="collapse abc" aria-labelledby="" data-parent="#accordionExample">
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table w-100 cart-table table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>Invoice Date</th>
                              <th>Invoice #</th>
                              <th>PO #</th>
                              <th>Warehouse</th>
                              <th>Invoice Total</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tr *ngFor="let order of monthData.data">
                            <td>{{ order.created_at | date }}</td>
                            <td>{{ ("00000"+order.id).slice(-8) }}</td>
                            <td>{{ order.purchase_order_no }}</td>
                            <td>{{ getWarehouseNames(order) }}</td>
                            <td>{{order.total | currency: '$ ' }}</td>
                            <td>
                              <div class="vad-btn" style="cursor: pointer;" (click)="downloadFile(order.id)">
                                <span class="bg-black"><i class="fa fa-download text-white"></i></span>
                                <button class="btn invoice-btn text-center w-100" (click)="onViewOrder(order)"> View
                                  Invoice</button>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card" *ngIf="myOrders && myOrders.length <= 0">
                  <div class="card-header">
                    <h2 class="mb-0">
                      No data found.
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <ng-template [ngIf]="showOrderDetail">
              <a href="javascript:void(0)" (click)="showOrderDetail = !showOrderDetail" class="black text-black">
                <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
              </a>
              <div class="row mt-4">
                <div class="col-md-12">
                  <div class="d-flex flex-row align-items-center gap-4 justify-content-between mb-2">
                    <h5 class="o-number">
                      Order Number: {{ currentOrder ? ("00000"+currentOrder.id).slice(-8) : '' }}
                    </h5>
                    <h5 class="o-number">
                      Order Date: {{ parseDate(currentOrder?.order_items[0]?.created_at) }}
                    </h5>
                  </div>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-4">
                  <p class="cart-table">
                    <span class="bold">Delivery For:</span>
                    <br />
                    {{ currentOrder?.billing.first_name + ' ' + currentOrder?.billing.last_name }}
                    <br />
                    {{ currentOrder?.billing.last_name }}
                    <br />
                    {{ currentOrder?.billing.email }}
                  </p>
                </div>
                <div class="col-md-4">
                  <p class="cart-table">
                    <span class="bold">Shipping Address:</span>
                    <br />
                    {{ currentOrder?.shipping.address }}
                    <br />
                    {{ currentOrder?.shipping.city }}, {{ currentOrder?.shipping.country }}
                    <br />
                    {{ currentOrder?.shipping.phone }}
                  </p>
                </div>
                <div class="col-md-4">
                  <p class="cart-table">
                    <span class="bold">Billing Address:</span>
                    <br />
                    {{ currentOrder?.billing.address }}
                    <br />
                    {{ currentOrder?.billing.city }}, {{ currentOrder?.billing.country }}
                    <br />
                    {{ currentOrder?.billing.phone }}
                  </p>
                </div>
              </div>
            
              <div class="row" *ngIf="currentOrder?.order_notes">
                <div class="col-md-12">
                  <p>Order Notes: <br /> {{ currentOrder?.order_notes }}</p>
                </div>
              </div>
            
              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table w-100 cart-table vr-cart-table table-bordered">
                      <tbody>
                        <tr class="bg-row">
                          <td>Product</td>
                          <td>Description</td>
                          <td>Quantity</td>
                          <td>Price</td>
                        </tr>
                        <ng-container *ngFor="let item of currentOrder?.order_items">
                          <tr>
                            <td>
                              <!-- Check if item is an addon -->
                              <ng-container *ngIf="item.is_addon === 1">
                                <!-- Check if addon image exists, and apply the same base path logic -->
                                <img [src]="basePathImage + item.addon?.image_1" [alt]="item.addon?.title" class="img-fluid" style="width:150px">

                              </ng-container>
                              
                              
                              <!-- Otherwise, display the product image if not an addon -->
                              <ng-container *ngIf="!item.is_addon">
                                <img [src]="item?.product?.images | baseImage | imagePath" [alt]="item.name" class="img-fluid" style="width:150px">
                              </ng-container>
                            </td>
                            <td>
                              <h2>{{ item.is_addon === 1 ? item.addon?.title : item.name }}</h2>
                              <h3 *ngIf="!item.is_addon">
                                <span>Size</span> {{ item.size }}
                              </h3>
                              <h3 *ngIf="!item.is_addon">
                                <span>Bolt Pattern</span> {{ item.bolt_pattern }}
                                <ng-container *ngIf="item.selected_bolt_pattern">
                                  {{ item.selected_bolt_pattern === 'recommended' ? '(Recommended)' : '(Selected: ' + item.selected_bolt_pattern + ')' }}
                                </ng-container>
                              </h3>
                              <h3 *ngIf="!item.is_addon">
                                <span>Offset</span> {{ item.offset }}
                                <ng-container *ngIf="item.selected_offset">
                                  {{ item.selected_offset === 'recommended' ? '(Recommended)' : '(Selected: ' + item.selected_offset + ')' }}
                                </ng-container>
                              </h3>
                              <h3 *ngIf="item.vehicle_year_make_model && !item.is_addon">
                                <span>Vehicle Year Make Model</span> {{ item.vehicle_year_make_model }}
                              </h3>
                            </td>
                            <td>
                              <p *ngFor="let qty of item.item_quantity">
                                {{ qty.quantity }} ({{ qty.warehouse.code }})
                              </p>
                            </td>
                            <td>
                              <p>{{ item.sale_price | currency: '$ ' }}</p>
                            </td>
                          </tr>
            
                          <tr *ngIf="item.custom_finish && !item.is_addon">
                            <td>
                              <img [src]="item.custom_finish.image | baseImage | imagePath" [alt]="item.custom_finish.name" class="img-fluid" style="width:150px">
                            </td>
                            <td>
                              <h3><span>Custom Finish</span> {{ item.custom_finish.finish_name }}</h3>
                            </td>
                            <td>
                              <p>{{ item.quantity }}</p>
                            </td>
                            <td>
                              <p>{{ item.custom_finish_price * item.quantity | currency: '$ ' }}</p>
                            </td>
                          </tr>
                        </ng-container>
            
                        <ng-container *ngIf="hasCostPerWheel()">
                          <tr>
                            <td class="text-left" colspan="4">
                              <h4>Bolt pattern & Offset Drilling</h4>
                            </td>
                          </tr>
                          <ng-container *ngFor="let item of currentOrder?.order_items">
                            <tr *ngIf="item.cost_per_wheel">
                              <td>
                                <img [src]="assets/img/no_image_placeholder.png" [alt]="item.name" class="img-fluid" style="width:150px">
                              </td>
                              <td>
                                <h3 *ngIf="item.selected_bolt_pattern">
                                  <span>Bolt Pattern</span> {{ item.selected_bolt_pattern === 'recommended' ? 'Recommended' : item.selected_bolt_pattern }}
                                </h3>
                                <h3 *ngIf="item.selected_offset">
                                  <span>Offset</span> {{ item.selected_offset === 'recommended' ? 'Recommended' : item.selected_offset }}
                                </h3>
                              </td>
                              <td>
                                <p>{{ item.quantity }}</p>
                              </td>
                              <td>
                                <p>{{ item.cost_per_wheel * item.quantity | currency: '$ ' }}</p>
                              </td>
                            </tr>
                          </ng-container>
                        </ng-container>
            
                        <tr>
                          <td style="text-align: right" colspan="4">Sub Total: {{ currentOrder?.sub_total | currency: '$' }}</td>
                        </tr>
                        <tr>
                          <td style="text-align: right" colspan="4">Shipping: {{ currentOrder?.shipping_amount | currency: '$ ' }}</td>
                        </tr>
                        <tr>
                          <td style="text-align: right" colspan="4">VAT: {{ currentOrder?.vat | currency: '$ ' }}</td>
                        </tr>
                        <tr>
                          <td style="text-align: right" colspan="4">Discount: {{ currentOrder?.discount ? currentOrder?.discount : 0 | currency: '$ ' }}</td>
                        </tr>
                        <tr>
                          <td style="text-align: right" colspan="4">Total: {{ currentOrder?.total | currency: '$ ' }}</td>
                        </tr>
                        <tr *ngIf="currentOrder?.payment_type == 'twenty_percent'">
                          <td style="text-align: right" colspan="4">20% Paid Amount: {{ currentOrder?.paid_amount | currency: '$ ' }}</td>
                        </tr>
                        <tr *ngIf="currentOrder?.payment_type == 'twenty_percent'">
                          <td style="text-align: right" colspan="4">Outstanding Amount: {{ currentOrder?.outstanding_amount | currency: '$ ' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            
              <p class="vr-success mt-1 pb-4">
                Status:
                <span
                  [class.text-success]="currentOrder?.status === 3 || currentOrder?.status === 2"
                  [class.text-warning]="currentOrder?.status === 0 || currentOrder?.status === 1"
                  [class.text-danger]="currentOrder?.status === 4">
                  {{ currentOrder?.orderStatus | orderStatus }}
                </span>
              </p>
            </ng-template>
            
          </div>


        </div>
      </div>
    </div>

  </div>
</section>